// buildRestaurantSearchParams — pure assembly of restaurant-search request body.
//
// Extracted verbatim from `AIChatBot.js` (module-level `buildRestaurantSearchParams`)
// as part of the behavior-preserving refactor (issue #240). Maps a `diningSearch`
// payload (signaled by the AI chat response) into the request body sent to the
// restaurant AI endpoint, applying the source's exact field defaults
// ('Dinner', 'no preference', 'Casual', '', null).
//
// React-free and side-effect-free. As in the source, `diningSearch` is assumed
// present (the caller guards on `data.diningSearch && data.diningSearch.city`);
// no defensive guard the source lacked is added.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * @typedef {Object} RestaurantSearchParams
 * @property {string} city
 * @property {string} mealType
 * @property {string} cuisine
 * @property {string} occasion
 * @property {string} vibe
 * @property {number|null} partySize
 */

/**
 * Builds the restaurant-search request params from a dining-search payload.
 *
 * @param {Object} diningSearch - The AI-signaled dining-search payload.
 * @returns {RestaurantSearchParams} The assembled request params.
 */
export function buildRestaurantSearchParams(diningSearch) {
  return {
    city: diningSearch.city,
    mealType: diningSearch.mealType || 'Dinner',
    cuisine: diningSearch.cuisine || 'no preference',
    occasion: diningSearch.occasion || 'Casual',
    vibe: diningSearch.vibe || '',
    partySize: diningSearch.partySize || null
  };
}

export default buildRestaurantSearchParams;
